import { Injectable } from '@angular/core';
import { Observable, Observer, Subject, of} from 'rxjs';
import { environment } from './../../environments/environment';
import { map } from 'rxjs/operators';
const { Manager } = require("socket.io-client");
import { Socket } from './../shared/interfaces';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class LobbyService{

  draftSocket: Socket;
  updateLeague: Observer<any>;
  updateTournament: Observer<any>;
  fillLeague: Observer<any>;
  fillTournament: Observer<any>;
  cgObservable: Observable<any>;
  private currentGame = new Subject<any>(); // used by game selector component {game,abbr}

  constructor(private _utilsService: UtilsService) {
    const currentUserDeatail = JSON.parse(localStorage.getItem('currentUser'));
    const jwt = currentUserDeatail && currentUserDeatail.token ? currentUserDeatail.token : "";
    const draftSocket = new Manager(`${environment.draftUrl}`, {transports:['websocket'], query: {token: jwt}});
    this.draftSocket  =  draftSocket.socket("/");
    this.cgObservable = this.currentGame.asObservable();
    this.setCurrentGame({game:'all',abbr:'all',season:'29'});
  }

  setCurrentGame(game) {
    this.currentGame.next(game);
  }
  
  updateLeagueMember(): Observable<any> {
    return new Observable<any>(observer => {
      this.draftSocket.on('update_league_member', (res) => {
        observer.next(res);
      });
    });
  }

  updateTournamentMember(): Observable<any> {
    return new Observable<any>(observer => {
      this.draftSocket.on('update_tournament_member', (res) => {
        observer.next(res);
      });
    });
  }

  fillLeagueMember(): Observable<any> {
    return new Observable<any>(observer => {
      this.draftSocket.on('remove_filled_league', (res) => {
        observer.next(res);
      });
    });
  }

  fillTournamentMember(): Observable<any> {
    return new Observable<any>(observer => {
      this.draftSocket.on('remove_filled_tournament', (res) => {
        observer.next(res);
      });
    });
  }

  getLeagues(user_id, game='all') {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/fantasyLeague/get-contest/' + `${environment.DRAFT_ACCESS_TOKEN}`+'/'+game+'/'+user_id);
  }

  getTournaments(user_id, game='all') {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/fantasyLeague/get-contest-tournament/' + `${environment.DRAFT_ACCESS_TOKEN}`+'/'+game+'/'+user_id);
  }

  getFilters(user_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/lobby/get-filters/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + user_id);
  }

  getGames(page_type='') {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/games/listV2/' + `${environment.DRAFT_ACCESS_TOKEN}`+'?page_type='+page_type); 
  }

  getDrafted() {
    if (localStorage.getItem('draftedToday')) {
      const draftedToday = JSON.parse(localStorage.getItem('draftedToday'));
      if (draftedToday.expires < Date.now()) {
        return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/lobby/liveLeagues/' + `${environment.DRAFT_ACCESS_TOKEN}`, 'getDrafted');
      } else {
        return of({status:"success",leagues:draftedToday.value}).pipe(map(res=>res));
      }
    } else {
      return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/lobby/liveLeagues/' + `${environment.DRAFT_ACCESS_TOKEN}`, 'getDrafted');
    }
  }

  storeFilters(filters, user_id) {
    var data = {
      access_token: `${environment.DRAFT_ACCESS_TOKEN}`,
      filters:JSON.stringify(filters),
      user_id
    };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/lobby/save-filters', data, null, 'content-type-json');
  }

  getStaticContent(slug){
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/pages/detail/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + slug); 
  }
}
